module.exports = __webpack_public_path__ + "img/smile.7f63193f.svg";